import React from 'react';
import {
  Button,
  getRehydratableName,
  Typography,
  Sizes,
  Heading,
  FlexGrid,
  Rank,
  getClassNameFactory,
} from '@dcl/ui';
import { types, boldTypes } from '@dcl/ui/dist/elements/Heading';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import { propsToDataAttributes } from '@tr-digital/react-rehydrate';
import { ButtonKind, ButtonColor } from '@dcl/ui/dist/elements/Button';
import './index.css';
import { IBrowseExperienceBannerProps } from './BrowseExperienceBanner.types';

export const BrowseExperienceBanner: React.FC<IBrowseExperienceBannerProps> = (
  props
) => {
  const { title, description, link, buttonText, isNewTab } = props;
  const getClassName = getClassNameFactory(BrowseExperienceBanner.displayName);
  return (
    <div
      data-rehydratable={getRehydratableName(
        BrowseExperienceBanner.displayName
      )}
      {...propsToDataAttributes(props)}
      className={getClassName()}
    >
      <div className={getClassName({ descendantName: 'container' })}>
        <FlexGrid.Row className={getClassName({ descendantName: 'row' })}>
          <FlexGrid.Col
            sm={12}
            md={9}
            lg={9}
            className={getClassName({ descendantName: 'column' })}
          >
            <div
              className={getClassName({ descendantName: 'alignVertically' })}
            >
              <Heading
                type={types.Medium}
                boldType={boldTypes.bold}
                className={getClassName({ descendantName: 'heading' })}
                rank={Rank.Second}
                data-testid="BrowseExperienceBanner-heading"
              >
                {title}
              </Heading>
              <Typography
                type={Sizes.SMALL}
                tag={TypographyTags.P}
                className={getClassName({ descendantName: 'description' })}
                data-testid="BrowseExperienceBanner-description"
              >
                {description}
              </Typography>
            </div>
          </FlexGrid.Col>
          <FlexGrid.Col
            sm={12}
            md={3}
            lg={3}
            className={getClassName({ descendantName: 'column' })}
          >
            <div
              className={getClassName({
                descendantName: 'alignVertically',
                utilities: 'buttonAlign',
              })}
            >
              <Button
                kind={ButtonKind.LINK}
                color={ButtonColor.PRIMARY}
                shape="circular"
                href={link}
                newWindow={isNewTab}
              >
                {buttonText}
              </Button>
            </div>
          </FlexGrid.Col>
        </FlexGrid.Row>
      </div>
    </div>
  );
};

BrowseExperienceBanner.displayName = 'BrowseExperienceBanner';
